module.exports = __webpack_public_path__ + "static/sq1_book-866552edf8e9be4b4d099b166a1d7417.jpg";